import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Teleport as _Teleport } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 1,
  class: "ai-floating-help"
}
const _hoisted_3 = {
  key: 2,
  class: "ai-floating-help",
  role: "status"
}
const _hoisted_4 = {
  key: 0,
  class: "share-note"
}
const _hoisted_5 = { class: "guard-actions" }
const _hoisted_6 = {
  key: 1,
  class: "floating-recorder",
  "aria-label": "Ironbook recording controls"
}
const _hoisted_7 = {
  key: 1,
  class: "starting-help"
}
const _hoisted_8 = {
  key: 2,
  class: "floating-recorder",
  "aria-label": "Ironbook recording controls"
}
const _hoisted_9 = { class: "recording-state" }
const _hoisted_10 = {
  class: "timer",
  "aria-label": "Recorded duration"
}
const _hoisted_11 = {
  ref: "preview",
  autoplay: "",
  muted: "",
  playsinline: "",
  "aria-label": "Live preview of the shared screen"
}
const _hoisted_12 = { class: "preview-caption" }
const _hoisted_13 = {
  key: 1,
  class: "audio-only"
}
const _hoisted_14 = { class: "audio-status" }
const _hoisted_15 = ["aria-valuenow"]
const _hoisted_16 = {
  key: 2,
  class: "audio-hint"
}
const _hoisted_17 = { class: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AiShareGuide = _resolveComponent("AiShareGuide")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ai-floating-launcher", { idle: !_ctx.recording }])
  }, [
    (_ctx.recording)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.supported)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "ai-floating-open",
                disabled: _ctx.opening,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showPanel && _ctx.showPanel(...args)))
              }, [
                _cache[5] || (_cache[5] = _createElementVNode("svg", {
                  "aria-hidden": "true",
                  width: "16",
                  height: "16",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2"
                }, [
                  _createElementVNode("rect", {
                    x: "3",
                    y: "4",
                    width: "18",
                    height: "16",
                    rx: "2"
                  }),
                  _createElementVNode("rect", {
                    x: "11",
                    y: "11",
                    width: "8",
                    height: "7",
                    rx: "1"
                  })
                ], -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.opening ? 'Opening controls…' : _ctx.panel ? 'Show floating controls' : 'Float recording controls'), 1)
              ], 8, _hoisted_1))
            : (_openBlock(), _createElementBlock("span", _hoisted_2, "Floating controls need desktop Chrome or Edge. Recording controls remain on this page.")),
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.error), 1))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.target)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 1,
          to: _ctx.target
        }, [
          (_ctx.guard && !_ctx.guard.busy)
            ? (_openBlock(), _createElementBlock("main", {
                key: 0,
                class: _normalizeClass(["floating-recorder guard", { 'with-guide': _ctx.guard.attempts >= 2 }]),
                role: "alertdialog",
                "aria-labelledby": "guard-title",
                "aria-describedby": "guard-text"
              }, [
                _cache[6] || (_cache[6] = _createElementVNode("h2", { id: "guard-title" }, [
                  _createElementVNode("span", { class: "status-dot starting" }),
                  _createTextVNode("No call audio")
                ], -1)),
                _cache[7] || (_cache[7] = _createElementVNode("p", { id: "guard-text" }, "Only your microphone will be recorded. People on the call won’t be heard.", -1)),
                (_ctx.guard.attempts >= 2)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.guideNote), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "primary",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('share-again')))
                  }, "Share again with sound"),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('continue')))
                  }, "Continue — we’re all in the room")
                ]),
                (_ctx.guard.attempts >= 2)
                  ? (_openBlock(), _createBlock(_component_AiShareGuide, {
                      key: 1,
                      class: "guide-after"
                    }))
                  : _createCommentVNode("", true)
              ], 2))
            : (!_ctx.recording)
              ? (_openBlock(), _createElementBlock("main", _hoisted_6, [
                  _cache[9] || (_cache[9] = _createElementVNode("header", null, [
                    _createElementVNode("div", { class: "recording-state" }, [
                      _createElementVNode("span", { class: "status-dot starting" }),
                      _createElementVNode("strong", null, "Starting…")
                    ]),
                    _createElementVNode("span", { class: "picker-note" }, "Chrome’s picker is open")
                  ], -1)),
                  (_ctx.callAudio)
                    ? (_openBlock(), _createBlock(_component_AiShareGuide, {
                        key: 0,
                        note: _ctx.guard && _ctx.guard.attempts >= 2 ? _ctx.guideNote : ''
                      }, null, 8, ["note"]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_7, [...(_cache[8] || (_cache[8] = [
                        _createTextVNode("Choose what to share in Chrome’s picker on the Ironbook page, then click ", -1),
                        _createElementVNode("strong", null, "Share", -1),
                        _createTextVNode(". Recording starts right after.", -1)
                      ]))])),
                  _cache[10] || (_cache[10] = _createElementVNode("footer", null, "This panel closes if sharing is cancelled.", -1))
                ]))
              : (_openBlock(), _createElementBlock("main", _hoisted_8, [
                  _createElementVNode("header", null, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["status-dot", { paused: _ctx.paused }])
                      }, null, 2),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.paused ? 'Paused' : 'Recording'), 1)
                    ]),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.timeLabel), 1)
                  ]),
                  (_ctx.hasVideo)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["preview", { 'is-paused': _ctx.paused }])
                      }, [
                        _createElementVNode("video", _hoisted_11, null, 512),
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.previewUnavailable ? 'Preview unavailable · recording controls still work' : _ctx.paused ? 'Paused · nothing is being recorded' : 'Live preview · ' + _ctx.sourceLabel), 1)
                      ], 2))
                    : (_openBlock(), _createElementBlock("div", _hoisted_13, "Audio recording · no screen video")),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["audio-dot", { off: !_ctx.hasMicAudio }])
                      }, null, 2),
                      _createElementVNode("span", null, _toDisplayString(_ctx.hasMicAudio ? 'Microphone on' : 'Microphone not included'), 1),
                      (_ctx.hasMicAudio)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "mic-meter",
                            role: "meter",
                            "aria-label": "Microphone input level",
                            "aria-valuenow": _ctx.paused ? 0 : Math.round(_ctx.micLevel * 100),
                            "aria-valuemin": "0",
                            "aria-valuemax": "100"
                          }, [
                            _createElementVNode("span", {
                              style: _normalizeStyle({ width: (_ctx.paused ? 0 : Math.round(_ctx.micLevel * 100)) + '%' })
                            }, null, 4)
                          ], 8, _hoisted_15))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["audio-dot", { off: !_ctx.hasSharedAudio }])
                      }, null, 2),
                      _createElementVNode("span", null, _toDisplayString(_ctx.hasSharedAudio ? 'Computer audio included' : 'Computer audio not shared'), 1)
                    ])
                  ]),
                  (!_ctx.hasSharedAudio)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_16, [...(_cache[11] || (_cache[11] = [
                        _createTextVNode("People on the call won’t be in the recording. Next time, choose ", -1),
                        _createElementVNode("strong", null, "Entire Screen", -1),
                        _createTextVNode(" and turn on ", -1),
                        _createElementVNode("strong", null, "Share with system audio", -1),
                        _createTextVNode(" in Chrome’s picker. A single window never shares sound.", -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('pause')))
                    }, _toDisplayString(_ctx.paused ? '▶ Resume' : 'Ⅱ Pause'), 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "stop",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('stop')))
                    }, "■ Stop recording")
                  ]),
                  _cache[12] || (_cache[12] = _createElementVNode("footer", null, "Keep Ironbook open. Closing this panel keeps recording.", -1))
                ]))
        ], 8, ["to"]))
      : _createCommentVNode("", true)
  ], 2))
}